import React, { useContext } from 'react';

import { Box, Button, Skeleton, Stack, Typography } from '@mui/material';

import PropTypes from 'prop-types';

import Axios from '../../../Assets/Axios/Axios';

import ToastContext from '../../../Context/ToastContext';

import { COLORS } from '../../../Constant/COLORS';
import { ORDER_STATUS } from '../../../Constant/Enums';

import CardLayout from '../../../Components/CardLayout';
import { TypoPoppBlue, TypoPoppins } from '../../../Components/Typo';

import { UpdateOrderStatus } from '../../../Server/Mutation/index';

import { toLocalPhone } from '../../../Helpers';

/**
 * @param {{data:{
    id: string;
    dateTime: string;
    note: string;
    status: string;
    referenceId: string;
    place: string;
    professional: { fullName: string;mobileNumber: string}
    service:{ name: string;}
    package: { name: string; price: string;};
  }
  updateParentCards:() => void
}} props
 * @returns {JSX.Element}
 */

function JobRequestsResponseCard({ data, updateParentCards }) {
  const { showToastMessage } = useContext(ToastContext);

  async function handleClickCancel() {
    // const query = UpdateOrderStatus({
    //   orderUniqueID: data.id,
    //   orderStatus: ORDER_STATUS.CUSTOMER_CANCELLED,
    // });
    // const { errors } = await Axios({ query });

    // if (errors) {
    //   showToastMessage("Oops! We're sorry, we encountered an error while cancel your order.");
    //   return undefined;
    // }

    // showToastMessage('Order cancelled successfully', 'success');
    // updateParentCards();
  }

  return (
    <CardLayout>
      <TypoPoppBlue variant='h6' fontWeight={600} mb={1.2}>
        {data.professional.fullName}
      </TypoPoppBlue>

      <Stack direction={{ xs: 'column', sm: 'row' }} gap={3} justifyContent='space-between'>
        <Box
          display='grid'
          gridTemplateColumns='auto 1fr'
          rowGap={1}
          columnGap={2}
          sx={{ wordBreak: 'break-all' }}>
          <TypoPoppins>Reference ID</TypoPoppins>
          <TypoPoppins fontWeight={500}>{data.referenceId}</TypoPoppins>

          <TypoPoppins>Contact</TypoPoppins>
          <TypoPoppins fontWeight={500}>{toLocalPhone(data.professional.mobileNumber)}</TypoPoppins>

          <TypoPoppins>Job Title</TypoPoppins>
          <TypoPoppins fontWeight={500}>{data.service.name}</TypoPoppins>

          <TypoPoppins>Service Place</TypoPoppins>
          <TypoPoppins fontWeight={500}>{data.place}</TypoPoppins>

          <TypoPoppins>Event Date & time</TypoPoppins>
          <TypoPoppins fontWeight={500}>{data.dateTime}</TypoPoppins>

          <TypoPoppins>Package</TypoPoppins>
          <TypoPoppins fontWeight={500}>{data.package.name}</TypoPoppins>

          <TypoPoppins>Price</TypoPoppins>
          <TypoPoppins fontWeight={500}>{data.package.price}</TypoPoppins>

          <TypoPoppins alignSelf='start'>Note</TypoPoppins>
          <TypoPoppins fontWeight={500}>{data.note}</TypoPoppins>
        </Box>

        <Button
          variant='outlined'
          color='blue'
          onClick={handleClickCancel}
          sx={{ alignSelf: 'flex-end' }}>
          <Typography variant='caption' color={COLORS.blue} sx={{ pointerEvents: 'none' }}>
            Cancel
          </Typography>
        </Button>
      </Stack>
    </CardLayout>
  );
}

function getRandomWidth() {
  return Math.ceil(Math.random() * (100 - 50) + 50) + '%';
}

function SkeletonCard() {
  return (
    <Box boxSizing='border-box' width='100%' bgcolor={COLORS.dividerBlue} borderRadius={4} p={2}>
      <TypoPoppins variant='h6' fontWeight={600} mb={1.2}>
        <Skeleton width={getRandomWidth()} />
      </TypoPoppins>

      <Box display='grid' gridTemplateColumns='auto 1fr' rowGap={1} columnGap={2}>
        <TypoPoppins>
          <Skeleton width='12ch' />
        </TypoPoppins>
        <TypoPoppins>
          <Skeleton width={getRandomWidth()} />
        </TypoPoppins>
        <TypoPoppins>
          <Skeleton width='9ch' />
        </TypoPoppins>
        <TypoPoppins>
          <Skeleton width={getRandomWidth()} />
        </TypoPoppins>
        <TypoPoppins>
          <Skeleton width='13ch' />
        </TypoPoppins>
        <TypoPoppins>
          <Skeleton width={getRandomWidth()} />
        </TypoPoppins>
        <TypoPoppins>
          <Skeleton width='10ch' />
        </TypoPoppins>
        <TypoPoppins>
          <Skeleton width={getRandomWidth()} />
        </TypoPoppins>
        <TypoPoppins>
          <Skeleton width='4ch' />
        </TypoPoppins>
        <TypoPoppins>
          <Skeleton />
          <Skeleton width='80%' />
        </TypoPoppins>
      </Box>
    </Box>
  );
}

JobRequestsResponseCard.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    dateTime: PropTypes.string.isRequired,
    note: PropTypes.string.isRequired,
    status: PropTypes.oneOf(Object.values(ORDER_STATUS)).isRequired,
    referenceId: PropTypes.string.isRequired,
    place: PropTypes.string.isRequired,
    professional: PropTypes.shape({
      fullName: PropTypes.string.isRequired,
      mobileNumber: PropTypes.string.isRequired,
    }).isRequired,
    service: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    package: PropTypes.shape({
      name: PropTypes.string.isRequired,
      price: PropTypes.string.isRequired,
    }).isRequired,
  }),
  updateParentCards: PropTypes.func,
};

export default JobRequestsResponseCard;
export { SkeletonCard };
